<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="200"
    height="165"
    class="empty-cart-icon"
    viewBox="610,174.5,700,600"
  >
    <path
      id="CompoundPath 2"
      d="M778.78048,658.86473c37.65888,-13.39491 64.69574,-50.10481 64.69574,-93.29211c0,-54.51956 -43.08724,-98.71641 -96.23805,-98.71641c-3.34586,0 -6.65183,0.17514 -9.90969,0.51697l-10.52282,-48.61118c-4.86898,-20.77242 11.49035,-41.54485 32.71869,-41.54485l466.52852,-5.48076c21.22835,0 37.85566,20.83411 33.25473,41.66815l-61.38606,277.96828c-4.60098,20.83411 -30.4285,41.94378 -51.65505,42.21936c-72.35839,-0.24221 -244.41134,-0.83058 -308.21297,-1.01783c-21.22654,0.27558 -47.32206,-20.2212 -52.19104,-40.99362zM1015.05289,515.62661c6.36818,0 12.54136,-3.97766 12.54136,-12.66128c0,-7.17984 -4.86144,-12.17624 -12.10264,-12.17624c-7.67993,0 -12.73488,4.8991 -12.73488,12.61263c0,7.66489 5.34597,12.2249 12.29616,12.2249zM1019.21502,550.19945c-4.90605,-9.99528 -15.07076,-16.32922 -26.20515,-16.32922c-11.13439,0 -21.2991,6.33394 -26.20514,16.32922c14.91433,-13.36407 37.49597,-13.36407 52.4103,0zM970.72251,517.22757c6.36818,0 12.54136,-3.97766 12.54136,-12.66128c0,-7.17984 -4.86144,-12.17624 -12.10264,-12.17624c-7.67993,0 -12.73488,4.8991 -12.73488,12.61263c0,7.66489 5.34597,12.2249 12.29616,12.2249z"
      class="empty-cart-icon__background"
      stroke-opacity="0"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="0,0"
    />
    <path
      id="CompoundPath 1 1"
      d="M1015.05288,515.62661c-6.95019,0 -12.29616,-4.56 -12.29616,-12.2249c0,-7.71353 5.05496,-12.61263 12.73488,-12.61263c7.2412,0 12.10264,4.9964 12.10264,12.17624c0,8.68362 -6.17318,12.66128 -12.54136,12.66128z"
      class="empty-cart-icon__face"
      stroke="none"
      stroke-width="0"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-dasharray=""
    />
    <path
      id="Path 1"
      d="M785.86249,691.58075l-7.08201,-32.71602c37.65888,-13.39491 64.69574,-50.10481 64.69574,-93.29211c0,-54.51956 -43.08724,-98.71641 -96.23805,-98.71641c-3.34586,0 -6.65183,0.17514 -9.90969,0.51697l-10.52282,-48.61118c-4.86898,-20.77242 11.49035,-41.54485 32.71869,-41.54485l466.52852,-5.48076c21.22835,0 37.85566,20.83411 33.25473,41.66815l-61.38606,277.96828c-4.60098,20.83411 -30.4285,41.94378 -51.65505,42.21936c-72.35839,-0.24221 -244.41134,-0.83058 -308.21297,-1.01783c-21.22654,0.27558 -47.32206,-20.2212 -52.19104,-40.99362z"
      fill-opacity="0"
      class="empty-cart-icon__line"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="0,0"
    />
    <path
      id="Path 1"
      d="M650.99582,565.11161c0,-54.51957 43.08724,-98.71641 96.23805,-98.71641c53.15081,0 96.23805,44.19685 96.23805,98.71641c0,54.51956 -43.08724,98.71641 -96.23805,98.71641c-53.15081,0 -96.23805,-44.19685 -96.23805,-98.71641z"
      class="empty-cart-icon__line"
      fill-opacity="0"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="19,27"
    />
    <text
      id="PointText 1"
      x="51.91844"
      y="42.68756"
      transform="scale(14.39247,13.4102)"
      class="empty-cart-icon__zero"
      stroke-width="0.2"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-dasharray=""
      font-weight="normal"
      font-size="8"
      text-anchor="middle"
    >
      0
    </text>
    <text
      id="PointText 1"
      x="149.68628"
      y="107.83602"
      transform="scale(4.992,5.73459)"
      class="empty-cart-icon__text"
      stroke-width="0"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-dasharray=""
      font-weight="normal"
      font-size="8"
      text-anchor="middle"
    >
      Items
    </text>
    <path
      id="Path 1"
      d="M826.94148,428.66979c-7.92799,-4.23314 -11.7112,-16.47144 -7.56643,-24.47656l90.17564,-174.16314c4.14477,-8.00511 16.21753,-11.77702 24.14551,-7.54383l2.53424,1.35315c7.92799,4.23314 11.7112,16.47144 7.56643,24.47656l-90.17564,174.16314c-4.14477,8.00511 -16.21753,11.77702 -24.14551,7.54383z"
      class="empty-cart-icon__right-handle"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray=""
    />
    <path
      id="Path 1"
      d="M1176.23582,422.48196c-4.20365,7.96445 -16.37568,11.75493 -24.34406,7.58099l-173.36414,-90.81116c-7.96841,-4.17399 -11.73304,-16.31241 -7.52943,-24.27685l1.34373,-2.5459c4.20365,-7.96445 16.37568,-11.75493 24.34407,-7.58099l173.36414,90.81116c7.96841,4.17399 11.73304,16.31241 7.52943,24.27685z"
      class="empty-cart-icon__left-handle"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray=""
    />
    <path
      id="Path 1"
      d="M966.80473,550.19945c4.90605,-9.99528 15.07076,-16.32922 26.20514,-16.32922c11.1344,0 21.29911,6.33394 26.20515,16.32922c-14.91433,-13.36407 -37.49597,-13.36407 -52.4103,0z"
      class="empty-cart-icon__face"
      stroke-width="1"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-dasharray=""
    />
    <path
      id="Path 1"
      d="M970.72251,517.22758c-6.95019,0 -12.29616,-4.56 -12.29616,-12.2249c0,-7.71353 5.05496,-12.61263 12.73488,-12.61263c7.2412,0 12.10264,4.9964 12.10264,12.17624c0,8.68362 -6.17318,12.66128 -12.54136,12.66128z"
      class="empty-cart-icon__face"
      stroke="none"
      stroke-width="0"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-dasharray=""
    />
  </svg>
</template>

<style lang="scss" scoped>
.empty-cart-icon {
  &__background {
    fill: transparent;
    stroke: transparent;
  }

  &__line {
    fill: none;
    stroke: var(--card-text-color);
  }

  &__right-handle {
    fill: var(--company-color-1);
    stroke: transparent;
  }

  &__left-handle {
    fill: var(--company-color-2);
    stroke: transparent;
  }

  &__zero {
    fill: var(--company-color-1);
    stroke: transparent;
  }

  &__face {
    fill: var(--card-text-color);
    stroke: none;
  }

  &__text {
    fill: var(--card-text-color);
    stroke: none;
  }
}
</style>
